import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

type StrongSize = 'xs' | 'sm' | 'base'
type StrongWeight = 'medium' | 'semibold'
type StrongVariant = 'default' | 'primary'

interface StrongProps {
    children: ReactNode
    size?: StrongSize
    weight?: StrongWeight
    /** Colour variant. `default` inherits the surrounding text colour; `primary` uses the primary brand colour. */
    variant?: StrongVariant
    truncate?: boolean
    className?: string
    'data-testid'?: string
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const sizeClasses: Record<StrongSize, string> = {
    xs: 'text-xs',
    sm: 'text-sm',
    base: 'text-base',
}
const weightClasses: Record<StrongWeight, string> = {
    medium: 'font-medium',
    semibold: 'font-semibold',
}
const variantClasses: Record<StrongVariant, string> = {
    default: '',
    primary: 'text-primary',
}
/* eslint-enable i18next/no-literal-string */

export function Strong({children, size, weight = 'medium', variant = 'default', truncate, className, 'data-testid': testId}: StrongProps) {
    return (
        <span
            className={cn(
                weightClasses[weight],
                size && sizeClasses[size],
                variantClasses[variant],
                truncate && 'truncate',
                className,
            )}
            data-testid={testId}
        >
            {children}
        </span>
    )
}
